import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/$tenantKey/settings/')({
  beforeLoad: ({ params: { tenantKey } }) => {
    // マスタ設定を直接叩いた場合はルートにリダイレクト
    throw redirect({
      to: `/${tenantKey}`
    })
  }
})
